import type { TypedClient } from '@platform/openapi';
import { prefillOf } from '../customers/customer-form.ts';
import { TYPING_DELAY_MS, useDebouncedValue } from '../useDebouncedValue.ts';
import { useKeysetPages } from '../useKeysetPages.ts';
import { queryKeys, usePageContext } from '../usePageContext.ts';

const PICKER_PAGE_SIZE = 20;

const pageOf = (pageToken: string | null) => ({
  page_size: PICKER_PAGE_SIZE,
  ...(pageToken === null ? {} : { page_token: pageToken }),
});

export const useCustomerOptions = (api: TypedClient, text: string, opened: boolean) => {
  const { tenantId } = usePageContext();
  const settled = useDebouncedValue(text.trim(), TYPING_DELAY_MS);
  const phone = prefillOf(settled).phone;
  const byName = settled !== '' && phone === '';
  const pages = useKeysetPages({
    queryKey: queryKeys.customers(tenantId, { view: 'order-picker', phone }),
    resource: 'orders',
    enabled: opened && !byName,
    fetchPage: (pageToken) =>
      phone === ''
        ? api.get('/admin/customers', { query: pageOf(pageToken) })
        : api.post('/admin/customers/search', { body: { phone, ...pageOf(pageToken) } }),
  });
  return {
    customers: byName ? [] : pages.items,
    byName,
    loading: settled !== text.trim() || (!byName && pages.query.isPending),
    hasMore: !byName && pages.hasMore,
    loadingMore: pages.loadingMore,
    loadMore: pages.loadMore,
  };
};
